export const GT_HYGIENE: string = 'GT03-EXHY';



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/types/hygiene-type.ts